import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SearchPage } from './components/SearchPage';
import { BrowsePage } from './components/BrowsePage';
import { SchoolDetailPage } from './components/SchoolDetailPage';
import { WatchlistPage } from './components/WatchlistPage';
import { CampsBrowsePage } from './components/CampsBrowsePage';
import { LoginPage } from './components/auth/LoginPage';
import { SignupPage } from './components/auth/SignupPage';
import { ForgotPasswordPage } from './components/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './components/auth/ResetPasswordPage';
import { LinkAccountPage } from './components/auth/LinkAccountPage';
import { LogoutPage } from './components/auth/LogoutPage';
import { prefetchAllTaxonomies } from './api/positions';

function App() {
  // WI-15c: Pre-fetch position taxonomies for all known sport slugs on mount
  // so the cache is warm before the user selects a sport chip.
  // Fire-and-forget — failures are non-blocking and logged only.
  useEffect(() => {
    prefetchAllTaxonomies().catch((err) => {
      console.warn('Position taxonomy pre-fetch failed:', err);
    });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Search and school detail */}
        <Route path="/" element={<SearchPage />} />
        {/* 32e: School directory browse page */}
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/schools/:slug" element={<SchoolDetailPage />} />
        {/* 49: ID camps browse page */}
        <Route path="/camps" element={<CampsBrowsePage />} />

        {/* Watchlist (06-watchlist) */}
        <Route path="/watchlist" element={<WatchlistPage />} />

        {/* Auth flow (05-auth) */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Google OAuth account-linking confirmation (WI-39b) */}
        <Route path="/auth/link-account" element={<LinkAccountPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
